// extracted by mini-css-extract-plugin
module.exports = {"my_list_shows":"MyListShows_my_list_shows__F_IAk","my_list_shows_user_prompt":"MyListShows_my_list_shows_user_prompt__kwC09"};